import { useState, useEffect } from "react";
import { Search, AlignVerticalJustifyStart } from "lucide-react";

export function SearchBar({ onSearch }) {
    const [query, setQuery] = useState("");

    useEffect(() => {
        // Debounce the search input
        const handler = setTimeout(() => {
            // Only trigger search if query is not just empty spaces
            if (query.trim() !== "" || query === "") {
                onSearch(query);
            }
        }, 500); // 500ms delay

        return () => clearTimeout(handler);
    }, [query]);

    const handleSearch = () => {
        onSearch(query);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="mt-8 px-4 py-6 flex flex-col lg:flex-row items-center gap-4 rounded-lg shadow-md bg-gray-50 dark:bg-gray-800">
            <div className="relative w-full lg:flex-1">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                    type="text"
                    className="w-full border-2 border-gray-300 dark:border-gray-600 pl-10 pr-32 py-2 rounded-lg text-sm font-normal text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-900 focus:outline-none focus:border-blue-500"
                    placeholder="Search for skills, role, or keywords..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <button
                    onClick={handleSearch}
                    className="border-l dark:border-gray-600 absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 px-3 py-2 font-semibold hover:cursor-pointer transition"
                >
                    <Search className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}